<template>
  <section>
    <LoadingSpinner v-if="loading" />

    <div class="row" v-if="!loading && selected">
      <div class="col-md-9">
        <div>
          <div style="min-height: 180px" class="card notEffect p-3 mb-2">
            <div class="">
              <div class="row pt-2">
                <div class="col-1"></div>
                <div class="col-11">
                  <div
                    class="d-flex justify-content-between align-items-center"
                  >
                    <div class="d-flex align-items-center">
                      <h5>{{ selected.response_subject }}</h5>
                      <span
                        class="ml-2 mb-1 badge"
                        :class="statusBadge(selected.status)"
                        >{{ selected.status }}</span
                      >
                      <span
                        v-if="selected.is_automatic == '1'"
                        class="ml-2 mb-1 badge badge-primary"
                      >
                        automatic</span
                      >
                    </div>
                    <div class="">
                      <span class="email-info-right">{{
                        selected.response_date | formatDatePretty
                      }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row pt-3 pb-4">
                <div class="col-1">
                  <div class="position-relative">
                    <div class="position-absolute">
                      <span class="icoCircle mail"
                        ><span>
                          {{ selected.response_from | firstLetter }}
                        </span></span
                      >
                    </div>
                  </div>
                </div>
                <div class="col-11">
                  <div class="d-flex justify-content-between">
                    <div class="">
                      <span class="nameClient mb-1 d-inline font-weight-bold">{{
                        selected.response_from
                      }}</span>
                      <p class="nameClient mb-1 ml-2 d-inline">
                        <{{ selected.response_from }}>
                      </p>
                    </div>
                  </div>
                  <p class="">
                    <small> To: {{ selected.response_to }}</small>
                  </p>
                  <div class="mt-4">
                    <div>
                      <OpenAi
                        v-if="false && selected.response_to"
                        :email_id="selected.id"
                      >
                      </OpenAi>

                      <div v-if="selected.response_snippet" class="card">
                        <h6>Snippet</h6>
                        <p
                          v-html="
                            quoted_printable_decode(selected.response_snippet)
                          "
                          class="email-body"
                        >
                          {{ selected.response_snippet }}
                        </p>
                      </div>

                      <p
                        v-html="
                          quoted_printable_decode(selected.response_message)
                        "
                        class="email-body"
                      >
                        {{ selected.response_message }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <!-- button next -->
        <div class="mt-0 mb-2 d-flex justify-content-end">
          <button 
            class="btn btn-primary btn-block btn-sm" 
            @click="nextPage"
          >
            <i class="fas fa-arrow-right fa-2x text-gray-300"></i>
          </button>
        </div>
        <div class="card p-3" v-if="contact">
          <div>
             <strong>
                <div>
                  {{ contact.name | formatContactName( contact.email ) }} 
                  <a v-if="contact.linkedinurl" class="mx-2 d-inline"
                    :href="contact.linkedinurl" target="_blank" rel="noopener noreferrer">
                      <i class="icon-linkedin color-ln"></i>
                  </a>
                    <span v-if="contact.active == 1" class="float-right badge badge-pill badge-success text-white px-3 pt-0">
                      <small>{{ $t('lang.label.active') }}</small>
                    </span>
                    <!-- <span v-else class="float-right  badge badge-pill badge-secondary px-3  ml-2">
                      <small>{{ $t('lang.label.inactive') }}</small>
                    </span> -->
                </div>
              </strong>
          </div>
          <div v-if="isContactManager(contact)">
            <small>{{replaceChain(contact.job)}}</small>
          </div>
          
          <Phone v-if="contact.save"
            :phone="contact.phone" 
            icon="icon-user">
          </Phone>

          <div class="d-flex">

            <div class="input-group my-0 mx-0 px-0 py-0">
                    <button
                      type="button"
                      @click="showFlag = true"
                      class="btn btn-light btn-sm px-0 py-0 my-0 mx-0"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <span class="input-group-text px-1 py-0">
                        <img :src="flagActually" class="flag ml-0 mr-2" />
                        + {{ country_id.phone_code }}
                      </span>
                    </button>
                    <div class="dropdown-menu dropdown-menu-left">
                      <button
                        v-for="(country, i) of countriesFiltered.filter(
                          (e) => e.visible
                        )"
                        class="dropdown-item"
                        type="button"
                        @click="changeCountry(country.id)"
                        :key="i"
                      >
                        <img :src="flag2(country.id)" class="flag2" />
                        <span class="ml-2 small"
                          >+ {{ country.phone_code }} {{ country.name }}</span
                        >
                      </button>
                      <div class="col-12 px-4 py-2">
                        <span>Other country</span>
                        <input
                          class="my-1 border"
                          placeholder="Your country..."
                          type="text"
                          v-model="filterCountry"
                        />
                      </div>
                    </div>
                    <input
                      id="phone"
                      type="tel"
                      class="form-control ml-2 px-1"
                      v-model="contact.newPhone"
                      @input="validPhone"
                      required="true"
                    />
                  </div>       
                  <button
                    v-if="contact.newPhone"            
                    class="rounded-3 ml-1 mt-0 mb-0 border-0 px-2 bg-primary text-white"
                    @click="savePhoneContact(contact)"
                  >
                    <small>
                      <i class="icon-plus"></i>
                    </small>            
                  </button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { opportunitiesService, businessContactsService, countriesService } from "@/_services";
import Table from "@/components/Common/Table.vue";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import Pagination from "@/components/Common/Pagination.vue";
import { statusBadgeMixin, linksMixin } from "@/_mixins/";
import Phone from "@/components/Common/Phone.vue";
import OpenAi from "@/components/OpenAi/OpenAi.vue";


export default {
  name: "PhoneLookup",
  computed: {
    ...mapState({
      loading: (state) => state.emails.loading,
      selected: (state) => state.emails.selected.data,
      currentUser: (state) => state.authentication.user,
      isMenuCollapse: (state) => state.sidebar.isNavOpen,
      filtersSystem: (state) => state.campaigns.filtersSystem,
      Countries: (state) => state.optionsList.all["profile_countries"].data,
    }),
    flag() {
      const flag = this.flags.find((el) => el.id === this.language_id).text;
      return require("@/assets/images/flags/" + flag);
    },
    flag2() {
      return (countryId) => {
        const flag = this.countries.find((el) => el.id === countryId).iso;
        return require("@/assets/images/flags/" + flag + ".svg");
      };
    },
    clientPhoneQty() {
      return this.clients.length;
    },
  },
  mixins: [statusBadgeMixin, linksMixin],
  data() {
    return {
      optionsDefault: ["CA", "ES", "IT", "GB", "US", "FR", "DE"],
      flagActually: null,
      filterCountry: null,
      showFlag: true,
      countriesFiltered: [],
      countries: [],
      country_id: {
        id: "73",
        name: "France",
        iso: "fr",
        phone_code: "33",
        visible: true,
      },
      contactPhoneLookupRegistered: false,
      contact: {
        id: null,
        newPhone: null,
        phone: null,
        name: "",
        linkedinurl: "",
        job: "",
        active: false,
        save: false
      },            
      loadingChangePage: false,
      completeLoading: false,
      total: 5,
      pagination: {
        imported: false,
        refreshlist: false,
        selectfirst: false,
        cantPerPage: 15,
        currentPage: 1,
      },
      filters: [],
      filterkey: 2233,
      ordersStatus: [],
      fieldsLoading: true,
      sort: "",
      dir: "",
      keyFilter: 1,
      searchFilter: {},
      oldQuery: "  ",
      orderStatus: 10,
      //loading: true,
      typelist: 10,
      typelistPreparing: 10,
      filterColumn: [],
      clients: [],
      showEmptyImage: false,

      captainkey: 112000,
      model: {
        imported: false,
        refreshlist: false,
        selectfirst: false,
        cantPerPage: 25,
        currentPage: 1,
      },
      cols: [
        [
          {
            value: "task_open_hours",
            type: "time",
          },
        ],
        [
          {
            value: "link_id",
          },
        ],
        [
          {
            value: "link_status_temperature_updated",
          },
        ],
        [
          {
            value_label: "business_name",
            value_emit: "link_id",
            class: "text-primary",
            type: "emit",
            emit: "goToOpportunity",
          },
        ],
        [
          {
            value: "link_status_temperature_id",
            type: "itemBadge",
            class: "badge badge-primary",
            colors: [
              {
                id: 1,
                label: "Urgent",
                bgColor: "#008000",
                textColor: "#FFFFFF",
              },
              {
                id: 2,
                label: "Positive",
                bgColor: "#008000",
                textColor: "#FFFFFF",
              },
              {
                id: 3,
                label: "Introduction",
                bgColor: "#0000FF",
                textColor: "#FFFFFF",
              },
              {
                id: 4,
                label: "Wrong Contact",
                bgColor: "#0000FF",
                textColor: "#FFFFFF",
              },
              {
                id: 5,
                label: "Negative",
                bgColor: "#0000FF",
                textColor: "#FFFFFF",
              },
              {
                id: 6,
                label: "Calendar Inspection",
                bgColor: "#00FFFF",
                textColor: "#000000",
              },
              {
                id: 7,
                label: "Reschedule",
                bgColor: "#FFFF00",
                textColor: "#000000",
              },
              {
                id: 8,
                label: "Cold",
                bgColor: "#000000",
                textColor: "#FFFFFF",
              },
              {
                id: 9,
                label: "Other Answer",
                bgColor: "#FF9966",
                textColor: "#000000",
              },
            ],
          },
        ],
        [
          {
            value: "last_email_received",
          },
        ],
        [
          {
            value_label: "client_name",
            value_emit: "client_id",
            class: "text-primary",
            type: "emit",
            emit: "openClient",
          },
        ],
        [
          {
            value_label: "target_name",
            value_emit: "target_id",
            class: "text-primary",
            type: "emit",
            emit: "openTarget",
          },
        ],
        [
          {
            value: "target_language",
          },
        ],
      ],
      headers: [
        {
          label: "Time",
          percentage: "12.5%",
          class: "overflowhide",
          permission: "adminClients",
          id: 11,
        },
        {
          label: "Opportunity Id",
          percentage: "10.5%",
          class: "overflowhide",
          permission: "adminClients",
          id: 2,
        },
        {
          label: this.$t("lang.column.date"),
          percentage: "12.5%",
          class: "overflowhide",
          permission: "adminClients",
          id: 1,
        },
        {
          label: this.$t("lang.label.opportunity"),
          percentage: "10.5%",
          class: "overflowhide",
          permission: "adminClients",
          id: 2,
        },
        {
          label: "Opportunity temperature",
          percentage: "10.5%",
          class: "overflowhide",
          permission: "adminClients",
          id: 2,
        },
        {
          label: "Last email received",
          percentage: "10.5%",
          class: "overflowhide",
          permission: "adminClients",
          id: 2,
        },
        {
          label: "Client",
          percentage: "10.5%",
          class: "overflowhide",
          permission: "adminClients",
          id: 2,
        },
        {
          label: this.$t("lang.label.order"),
          percentage: "10.5%",
          class: "overflowhide",
          permission: "adminClients",
          id: 2,
        },
        {
          label: this.$t("lang.token.order_language"),
          percentage: "10.5%",
          class: "overflowhide",
          permission: "adminClients",
          id: 2,
        },
      ],
      getOrderNumber: 0,
      responseOrderNumber: 0,
    };
  },
  components: {
    Table,
    LoadingSpinner,
    Pagination,
    OpenAi,
    Phone
  },

  created() {
    this.startLoading()
    this.$store.dispatch("optionsList/getProfileCountries").then(() => {
        this.countries = this.Countries.map((el) => {
          return {
            ...el,
            iso: el.iso.toLowerCase(),
            visible: this.optionsDefault.includes(el.iso),
          };
        });
        this.countriesFiltered = this.countries;
        this.countryDefault();
    });
  },

 
  mounted() {
    //this.getPhoneLookupTotal();
    this.getData();
    this.udpdateHeader(this.$route.name);
    this.setCurrentRouteChild({ child: "" });
  },

  watch: {
    filterCountry(newValue) {
      this.countriesFiltered = this.countries.map((e) => ({ ...e }));
      if (newValue.length > 2) {
        this.countriesFiltered = this.countriesFiltered.filter((e) =>
          e.name.toUpperCase().includes(newValue.toUpperCase())
        );
        this.countriesFiltered.forEach((e) => (e.visible = true));
      }
    },
    country_id(newValue, oldValue) {
      if (newValue.id === "3333") {
        this.flagActually = null;
        return;
      }

      //if(newValue.id != "3333"){
      const flag = this.countries.find((el) => el.id === newValue.id).iso;
      this.flagActually = require("@/assets/images/flags/" + flag + ".svg");
      this.showFlag = true;
      //}
    }   
  },


  methods: {
    ...mapActions("headertopbar", {
      setCurrentRoute: "setRoute",
      setCurrentRouteChild: "setRouteChild",
    }),
    ...mapActions("emails", {
      getByIdAllSource: "getByIdAllSource",
      startLoading: "startLoading",
    }),
    udpdateHeader(route) {
      this.setCurrentRoute({ page: route });
    },
    hasPermissions(perm) {
      return this.$store.getters["authentication/hasPermissions"](perm);
    },

    validPhone() {
      
      // Reemplaza caracteres no numéricos ni guion
      this.contact.newPhone = this.contact.newPhone.replace(/[^0-9-]/g, "");

      // Limita a 9 caracteres
      if (this.contact.newPhone.length > 9) {
        this.contact.newPhone = this.contact.newPhone.slice(0, 9);
      }
    },

    changeCountry(countryId) {
      this.country_id = this.countries.find((e) => e.id === countryId);
    },

    countryDefault() {
      const flag = this.countries.find((el) => el.id == 73).iso;
      this.flagActually = require("@/assets/images/flags/" + flag + ".svg");
    },

    nextPage(){
       this.startLoading()
       this.markContactAsReviewed(this.contact.id, this.contact.email_response_id)
    },

    isContactManager(contact) {
      return contact.role != "Generic";
    },

    savePhoneContact(contact) {
      this.$swal({
        type: "warning",
        title: this.$t("lang.label.areyousure"),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33a2c",
        confirmButtonText: this.$t("lang.button.yes"),
        cancelButtonText: this.$t("lang.button.cancel"),
      }).then((result) => {
        const phoneToSave = '+' + this.country_id.phone_code +  contact.newPhone
        if (result.value) {
          businessContactsService
            .setPhone(contact.id, phoneToSave)
            .then((data) => {
              this.contact.phone = phoneToSave       
              this.contact.save = true     
              this.contact.newPhone = null
            });
        }
      });
    },

    getPhoneLookupTotal() {
      opportunitiesService.getPhoneLookup(28, "count").then((result) => {
        this.total = Number(result.count);
        // this.completeLoading = true;
      });
    },

    replaceChain(chain){
      if(chain!=null){
        var search = '&amp;';
        var str=chain;
        str=str.replace(new RegExp(search,"g") ,"&");
        return str
      }
    },

    openClient(client_id) {
      let url = "/clients/" + client_id;
      window.open(url, "_blank");
    },

    openTarget(target_id) {
      let url = "/orders/" + target_id;
      window.open(url, "_blank");
    },

    getData() {
      //this.completeLoading = false;
      let filters = this.filters;
      filters.cantPerPage = this.pagination.cantPerPage;
      filters.currentPage = this.pagination.currentPage;
      filters.getTotal = 0;

      opportunitiesService
        .getPhoneLookup("28", null, filters)
        .then((result) => {
          this.clients = result;
          
          this.contact.id  = result.bc_id
          this.contact.name  = result.bc_name
          this.contact.linkedinurl  = result.bc_linkedinurl          
          this.contact.job  = result.bc_role
          this.contact.active  = result.active
          this.contact.email_response_id = result.email_response_id

          this.getByIdAllSource({
            id: result.email_response_id
          });

          
        });
    },

    markContactAsReviewed(businessContactId, emailResponseId){
      businessContactsService
        .markContactAsReviewed(businessContactId, emailResponseId)
        .then((result) => {       
          if(!result.error) {
            this.contactPhoneLookupRegistered = true
             this.contact = {
              id: null,
              newPhone: null,
              phone: null,
              name: "",
              linkedinurl: "",
              job: "",
              active: false,
              save: false
            }
            this.getData()
          }                    
        })
        .catch((error) => console.log(error))
    },
    goToOpportunity(link_id) {
      window.open("/opportunities/" + link_id, "_blank");
    },

    quoted_printable_decode(str) {
      // eslint-disable-line camelcase

      if (str && str.indexOf("=E9") && !str.indexOf("http")) {
        var RFC2045Decode1 = /=\r\n/gm;
        // the RFC states against decoding lower case encodings, but following apparent PHP behavior
        var RFC2045Decode2IN = /=([0-9A-F]{2})/gim;
        var RFC2045Decode2OUT = function (sMatch, sHex) {
          return String.fromCharCode(parseInt(sHex, 16));
        };

        return str
          .replace(RFC2045Decode1, "")
          .replace(RFC2045Decode2IN, RFC2045Decode2OUT);
      }

      return str;
    },
  },
};
</script>

<style scoped>
.email-body {
  white-space: pre-wrap;
}

.email-body * {
  white-space: initial;
}

.flag {
  width: 25px;
}

.flag2 {
  width: 12px;
}
</style>

